<template>
    <Modal class="edit-creator-modal" :is_show="is_show_edit_modal" @click-bg="close" :class="{ 'is-loading': is_loading }">
        <header class="edit-header">
            <h2>Edit Creator Info</h2>
            <i @click="close"><svg-icon name="close" /></i>
        </header>
        <Scrollbar>
            <div class="user-info">

                <figure><img :src="values.userProfile.avatar_full_url" @error="imageError($event)" /></figure>
                <div :class="['class-' + values.status]">
                    <span
                        v-if="values.status === -10 && values.motom_user_id !== null && values.motom_user_unique_key !== null">Joined</span>
                    <span
                        v-else-if="values.status === -10 && values.motom_user_id === null && values.motom_user_unique_key === null">Pending</span>
                    <span v-else>{{ values.status_text }}</span>
                    <!-- {{ values.status_text }} -->
                </div>

                <div class="toggle">
                    <p :class="['class-' + values.anchor_page_status]">
                        <span>
                            {{ values.anchor_page_status_text }}
                        </span>
                        <Switch
                            :disabled="!permission_creator.disableCreators.permission"
                            v-if="(values.status === 100 && values.anchor_page_status === 100) || (values.status === 100 && values.anchor_page_status === 0)"
                            :checked="(values.anchor_page_status === 100)" @click.native="handleStoreFront()" />
                    </p>
                </div>
                <div class="link" v-if="values.status === 100 && values.anchor_page_status === 100 && values.share_link"><a
                        :href="values.share_link" target="_blank">View Storefront <svg-icon name="share" /></a></div>
            </div>

            <Form :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }" class="user-form-wrap"
                :class="{ 'is-error': is_error }" ref="form">
                <div class="name-box">
                    <div class="name-item">
                        <label class="label">First name</label>
                        <Field type="text" k="first_name" placeholder="First name" :default_value="values.first_name"
                            :error_msg="errors.first_name" :is_success="success.first_name" @update="update"
                            :ref="(el) => { els.push(el) }" :ready_only="permission_creator.editBasicInfo.permission===0"/>
                    </div>
                    <div class="name-item">
                        <label class="label">Last name</label>
                        <Field type="text" k="last_name" placeholder="Last name" :default_value="values.last_name"
                            :error_msg="errors.last_name" :is_success="success.last_name" @update="update"
                            :ref="(el) => { els.push(el) }" :ready_only="permission_creator.editBasicInfo.permission===0"/>
                    </div>
                </div>
                <br>
                <label class="label" v-if="$store.state.user_data.is_motom_internal_user">Contact email</label>
                <Field type="text" k="email" 
                    v-if="$store.state.user_data.is_motom_internal_user"
                    :default_value="(values.original_email || values.original_email === null) ? values.original_email : values.email" 
                    :placeholder="permission_creator.editBasicInfo.permission===0 && (!values.original_email || !values.original_email) ? '---':'Enter a valid email'" :error_msg="errors.email" 
                    :is_success="success.email" @update="update" :ref="(el) => { els.push(el) }" 
                    :ready_only="permission_creator.editBasicInfo.permission===0"/>
                <br>
                <label class="label">Social handle(s)</label>
                <p class="desc">We use this to authenticate Motom creator profiles. Once they have connected their social accounts, you will not be able to edit this section.</p>
                <span v-if="values.status === 100 && values.tiktok_handle && !edit_tiktok_handle" class="ico-social">
                    <svg-icon name="tiktok" /> www.TikTok.com/{{ values.tiktok_handle }}
                    <tippy v-if="values.edit_tiktok_handle && permission_creator.editBasicInfo.permission" @click="edit_tiktok_handle = true"
                        content="Click to edit TikTok handle">
                        <svg-icon name="pen" />
                    </tippy>
                </span>
                <Field v-show="values.status !== 100 || edit_tiktok_handle" type="icon" k="tiktok_handle" befter_icon="tiktok"
                    befter_text="www.TikTok.com/" placeholder="@username" :default_value="values.tiktok_handle"
                    :error_msg="errors.tiktok_handle" :is_success="success.tiktok_handle" @update="update"
                    :ref="(el) => { els.push(el) }" />
                <span v-if="values.status === 100 && values.instagram_handle && !edit_instagram_handle" class="ico-social">
                    <svg-icon name="instagram" /> www.Instagram.com/{{ values.instagram_handle }}
                    <tippy v-if="values.edit_instagram_handle && permission_creator.editBasicInfo.permission" @click="edit_instagram_handle = true"
                        content="Click to edit Instagram handle">
                        <svg-icon name="pen" />
                    </tippy>
                </span>
                <Field v-show="values.status !== 100 || edit_instagram_handle" type="icon" k="instagram_handle"
                    befter_icon="instagram" befter_text="www.Instagram.com/" placeholder="username"
                    :default_value="values.instagram_handle" :error_msg="errors.instagram_handle"
                    :is_success="success.instagram_handle" @update="update" :ref="(el) => { els.push(el) }" />
                <p v-if="is_error" v-html="error_msg" class="error-msg"></p>

                <br>
                <label class="label" v-if="$store?.state?.user_data?.merchant_account?.is_enable_chatroom">Chat</label>
                <div class="switch-box" v-if="$store?.state?.user_data?.merchant_account?.is_enable_chatroom">
                    <strong>Disable chat</strong>
                    <p class="desc">If you disable the chat, you will no longer be able to send or receive messages to or from the creator.</p>
                    <Switch :checked="values.anchor_page_status === 0 || (values.chatroom_is_disable === 1)" @click.native="setChatroom(1)" :disabled="permission_creator.editChatPermissions.permission===0"/>
                </div>
                <div class="switch-box" v-if="$store?.state?.user_data?.merchant_account?.is_enable_chatroom && values.chatroom_is_disable !== 1">
                    <strong>Send-only</strong>
                    <p class="desc">If you block replies, you will still be able to send messages to the creator, but they will not be able to respond or DM you directly.</p>
                    <Switch :checked="values.anchor_page_status === 0 || (values.chatroom_is_mute === 1)" @click.native="setChatroom(2)" :disabled="permission_creator.editChatPermissions.permission===0"/>
                </div>

                <div class="coll-chec program-tag-box-big">
                    <label class="label">Tag</label>
                    <dl class="tag-line program-tag-box" v-if="permission_creator.addOrEditCreatorTags.permission || values.merchant_account_tags.length > 0">
                        <dd v-if="values.merchant_account_tags !== undefined" :class="['program-tag-box-dd','edit-program-tag-box-dd']"  @mouseover="values.hover_tag_list_box=true" @mouseleave="values.hover_tag_list_box = false">
                            <div @click.stop="values.tag_open= !values.tag_open; values.tag_all_open=false;" class="add-tag-btn" v-if="permission_creator.addOrEditCreatorTags.permission"><svg-icon name="tag-plus" /></div>
                            
                            <Badage class="tag-item-box" v-for="(v,k) in values.merchant_account_tags.filter((ee,kk)=>{return kk < 8 })" :key="k" :value="v.text" :show_tippy="true">
                                <svg-icon name="close" @click.stop="handleSelectTag({tag:v, row:values },'from_outside')" v-if="permission_creator.addOrEditCreatorTags.permission"/>
                            </Badage >
                            <Badage @click.stop="values.tag_all_open= !values.tag_all_open; values.tag_open=false;" v-if="values.merchant_account_tags.length - 8 > 0" :value="`+${ values.merchant_account_tags.length - 5}`"></Badage>
                        </dd>
                    </dl>
                    <span class="tag-line" v-else>---</span>
                    <DropdownHashtag :tags="values.tags" :selected_tags="values.merchant_account_tags"
                        :tag_type="'creator_tag'"
                        @select-tag="selectTag"
                        @closeKey="values.tag_open=false"                          
                        :open_key="values.tag_open"
                        :row="values"
                        :drop_css="'top:unset;left:0px;bottom:36px'"
                        :index="9999"
                    />
                    <HashtagPopup 
                        :tags="values.merchant_account_tags"
                        :row="values" 
                        :open_key="values.tag_all_open"
                        :drop_css="'top:unset;left:0px;bottom:36px'"
                        :index="9999"
                        @closeKey="values.tag_all_open=false;"
                        @open-cre-tag="values.tag_open=true;values.tag_all_open=false;"
                    />
                </div>

                <div class="coll-chec" v-if="$store.state.user_data.merchant_account.is_allow_customize_collection_cover">
                    <label class="label">Collections</label>
                    <Checkbox
                        class="w-100-p-check"
                        label_text="Enable this creator to upload custom cover images on their storefront collections."
                        :checked="values.is_allow_customize_collection_cover"
                        @click.native="values.is_allow_customize_collection_cover = !values.is_allow_customize_collection_cover"
                        :align_start="true" 
                        :disabled="permission_creator.editStorefrontPermissions.permission===0"
                        />
                </div>

                <br>
                <div class="btn-wrap">
                    <Button v-if="is_can_delete" type="button" color="no-color" size="32"
                        @click.native="deleteCreator">Delete</Button>
                    <Button type="submit" color="dark-blue" size="32">Save</Button>
                </div>
            </Form>
        </Scrollbar>
    </Modal>

    <Modal :is_show="is_show_alert_modal" class="alert-modal width-380" @click-bg="is_show_alert_modal = false" >
        <div class="box">
            <header class="delete-header" v-if="values.status === 100 && values.anchor_page_status === 100">Deactivate storefront(s)?</header>
            <header class="delete-header" v-else-if="values.status === 100 && values.anchor_page_status === 0">Enable storefront?</header>
            <p v-if="values.status === 100 && values.anchor_page_status === 100">The storefront link(s) will no longer be active, but all of the data will remain in the Anchor portal.</p>
            <p v-else-if="values.status === 100 && values.anchor_page_status === 0">1 selected creator ready to enable storefront</p>

            <div class="btns">
                <Button type="button" color="no-color" size="32" @click.native="toggle(1)">No</Button>
                <Button type="button" color="dark-blue" size="32" @click.native="toggle(2)">Yes</Button>
            </div>
        </div>
    </Modal>
    
    <Modal :is_show="is_show_alert_modal2" class="alert-modal width-380" @click-bg="is_show_alert_modal2 = false">
        <div class="box">
            <header class="delete-header">Disable conversation?</header>
            <p>Both you and creator will no longer be able to send messages to each other. Please make sure to notify the creator before disabling the conversation.</p>

            <div class="btns">
                <Button type="button" color="no-color" size="32" @click.native="is_show_alert_modal2 = false">No</Button>
                <Button type="button" color="dark-blue" size="32" @click.native="is_show_alert_modal2 = false; values.chatroom_is_disable = 1">Yes, confirm</Button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="is_show_alert_modal3" class="alert-modal" @click-bg="is_show_alert_modal3 = false">
        <div class="box">
            <header class="delete-header">Block/Mute conversation?</header>
            <p>Once muted, you can still send messages to this creator, however this creator will no longer be able to send messages to you.</p>

            <div class="btns">
                <Button type="button" color="no-color" size="32" @click.native="is_show_alert_modal3 = false">No</Button>
                <Button type="button" color="dark-blue" size="32" @click.native="is_show_alert_modal3 = false; values.chatroom_is_mute = 1">Yes, confirm</Button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="is_show_alert_modal4" class="alert-modal" @click-bg="is_show_alert_modal4 = false">
        <div class="box">
            <header class="delete-header">Can't enable conversation</header>
            <p>This storefront currently is disabled, you can enable a conversation without re-enabling the storefront.</p>

            <div class="btns">
                <Button type="button" color="dark-blue" size="32" @click.native="is_show_alert_modal4 = false;">Ok</Button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="tag_remove_modal" class="alert-modal" @click-bg="tag_remove_modal = false">
        <div class="box remove-box">
            <header class="delete-header" >Remove tag?</header>
            <p style="word-break: break-all;">Are you sure you want to remove <br/>{{ handle_remove_tag_value.tag.text }}?</p>
            <div class="btns">
                <Button type="button" color="no-color" size="32" @click.stop="tag_remove_modal = false">No</Button>
                <Button type="button" color="dark-blue" size="32" @click.stop="tag_remove_modal = false;selectTag( handle_remove_tag_value ,'from_outside')">Yes, confirm</Button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Switch from '@/components/ui/Switch.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Badage from '@/components/ui/Badage.vue';
import HashtagPopup from '@/components/HashtagPopup.vue';
import DropdownHashtag from '@/components/DropdownHashtag.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import { getTags, handleCreTag ,selectTag,editOrDelCreTag } from '@/utils/CreatorTagFun';

import * as yup from 'yup';
import { Tippy } from 'vue-tippy';

export default {
    name: 'edit-creator',
    emits: ['save'],

    components: {
        Field,
        Button,
        Form,
        Modal,
        Switch,
        Tippy,
        Checkbox,
        Badage,
        DropdownHashtag,
        HashtagPopup,
        Scrollbar,
    },

    computed:{
        permission_creator(){
            return this.$store.state.user_data?.permission_list?.creatorManagement;
        }
    },

    data() {
        return {
            is_loading: false,
            is_show_edit_modal: false,
            is_show_alert_modal: false,
            is_show_alert_modal2: false,
            is_show_alert_modal3: false,
            is_show_alert_modal4: false,
            is_can_delete: false,
            is_error: false,
            edit_tiktok_handle: false,
            edit_instagram_handle: false,
            error_msg: '',

            els: [],

            values: {},

            schema: yup.object().shape({
                first_name: yup.string().required('Cannot leave blank.'),
                last_name: yup.string().required('Cannot leave blank.'),
                email:yup.string()
                .test(
                    'is-valid-email',
                    'Invalid email address.',
                    (value) => 
                        !value || /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/.test(value)
                ).notRequired(),
                instagram_handle: yup.string()
                    .max(30, 'Your handle can\'t exceed 30 characters')
                    .matches(
                        /(^$)|^[aA-zZ0-9_.]+$/,
                        `Invalid social handle`
                    ).notRequired(),
                tiktok_handle: yup.string()
                    .max(30, 'Your handle can\'t exceed 30 characters')
                    .matches(
                        /(^$)|^[@][aA-zZ0-9_.]+$|^[aA-zZ0-9_.]+$/,
                        `Invalid social handle`
                    ).notRequired(),
            }).test(
                'at-least-one',
                'You must fill at least one of email, instagram_handle, or tiktok_handle.',
                function (values) {
                    const { email, instagram_handle, tiktok_handle } = values || {};
                    const errors = [];

                    // 检查是否至少填写了一个字段
                    if (!email && !instagram_handle && !tiktok_handle) {
                    errors.push(
                        this.createError({
                        path: 'email',
                        message: 'Cannot leave blank.',
                        }),
                        this.createError({
                        path: 'instagram_handle',
                        message: 'Cannot leave blank.',
                        }),
                        this.createError({
                        path: 'tiktok_handle',
                        message: 'Cannot leave blank.',
                        })
                    );
                    }

                    // 检查单独字段的规则
                    if (email && !this.schema.fields.email.isValidSync(email)) {
                    errors.push(
                        this.createError({ path: 'email', message: 'Invalid email address.' })
                    );
                    }
                    if (instagram_handle && !this.schema.fields.instagram_handle.isValidSync(instagram_handle)) {
                    errors.push(
                        this.createError({ path: 'instagram_handle', message: 'Invalid social handle.' })
                    );
                    }
                    if (tiktok_handle && !this.schema.fields.tiktok_handle.isValidSync(tiktok_handle)) {
                    errors.push(
                        this.createError({ path: 'tiktok_handle', message: 'Invalid social handle.' })
                    );
                    }

                    // 如果有任何错误，则抛出
                    if (errors.length) throw new yup.ValidationError(errors);

                    return true; // 验证通过
                }
                ),
            all_tags:[],
            tag_remove_modal:false,
            handle_remove_tag_value:{//抓住準備要unbind的tag和creator
                row:null,
                tag:''
            },
            check_not_enable_creator:0,
        }
    },

    methods: {
        handleStoreFront() {
            if(!this.permission_creator.disableCreators.permission){
                return;
            }
            this.is_show_alert_modal = true;
        },

        update(obj) {
            this.is_error = false;
            this.error_msg = '';
            Object.keys(this.values).forEach(key => {
                if (key === obj.key) this.values[key] = obj.val;
            });
        },

        setChatroom(type) {
            if(this.permission_creator.editChatPermissions.permission===0){
                return;
            }

            if (this.values.anchor_page_status !== 100) {
                this.is_show_alert_modal4 = true;
                return;
            } else {
                if (type === 1) {
                    if (this.values.chatroom_is_disable !== 1) {
                        this.is_show_alert_modal2 = true;
                    } else {
                        this.values.chatroom_is_disable = 0;
                    }
                } else if (type === 2) {
                    if (this.values.chatroom_is_mute !== 1) {
                        this.is_show_alert_modal3 = true;
                    } else {
                        this.values.chatroom_is_mute = 0;
                    }
                }
            } 


        },

        toggle(type) {
            this.is_show_alert_modal = false;


            if (type === 2) {
                if (this.values.anchor_page_status === 100) {
                    this.values.anchor_page_status = 0;
                    this.values.anchor_page_status_text = 'Disabled'
                } else if (this.values.anchor_page_status === 0) {
                    this.values.anchor_page_status = 100;
                    this.values.anchor_page_status_text = 'Active'
                }
            }
        },

        deleteCreator() {
            this.EventBus.emit('delete-creator', this.values.id);

        },

        submit() {
            this.is_error = false;
            this.is_loading = true;

            if (this.values.tiktok_handle) {
                this.values.tiktok_handle = this.values.tiktok_handle.replace(/@/gi, '')
            }

            this.values.is_allow_customize_collection_cover = this.values.is_allow_customize_collection_cover ? 1 : 0;

            this.$ajax('/creator/edit', {
                method: 'post',
                data: this.values,
            }).then(res => {
                this.close();
                res.data.data.merchant_account_tags = this.values.merchant_account_tags;
                this.$emit('save', res.data.data);
                this.is_loading = false;

            }).catch(err => {
                this.is_loading = false;
                
                if (err && err.response && err.response.data.data) {
                    // console.log(err.response.data)
                    this.is_error = true;
                    this.error_msg = err.response.data.data.message;
                    this.$refs.form.init();
                }

            });
        },

        editOrDelCreTag(item){
            editOrDelCreTag( { data:this.values , ...item })
        },

        async open(data,num) {
            // console.log(data)
            if(num){
                this.check_not_enable_creator=num;
            }
            this.els = [];
            await this.getTags();
            const clone_obj = JSON.parse(JSON.stringify(data));
            this.is_error = false;
            this.error_msg = '';
            this.values = clone_obj;
            this.values.anchor_creator_id = clone_obj.id;
            if (!this.values.userProfile) {
                this.values.userProfile = {
                    avatar_full_url: require('@/assets/images/user.png')
                }
            }

            handleCreTag(this.values, this.all_tags);

            this.is_show_edit_modal = true;
            this.edit_tiktok_handle = false;
            this.edit_instagram_handle = false;
            this.is_can_delete = (clone_obj.status === 10 || ((clone_obj.status === 100 && clone_obj.anchor_page_status === 10) || (clone_obj.status === 100 && clone_obj.anchor_page_status === 20) || (clone_obj.status === 100 && clone_obj.anchor_page_status === -10)));

            setTimeout(() => {
                // this.is_init = true;
                this.els.forEach(el => {
                    el.sync();
                });

                setTimeout(() => {
                    this.$refs.form.init();
                }, 300);
            }, 500);

        },

        async getTags() {
            let tagData= await getTags(this);
            if(tagData.data){
                this.all_tags=tagData.orgData;
            }
        },

        close() {
            this.is_show_edit_modal = false;
            this.is_error = false;
            this.error_msg = '';
            this.EventBus.emit('update-modal-creator');
        },

        imageError(event) {
            event.target.src = require('@/assets/images/user.png');
        },

        //這邊會處理單人的tag刪減增加,API處理會在元件裡面做完(除了有spec_text的要另外CALL)
        selectTag(item,spec_text){
            selectTag( item, spec_text, this); 
        },

        handleSelectTag(item){
            this.handle_remove_tag_value.row=item.row;
            this.handle_remove_tag_value.tag=item.tag;
            this.tag_remove_modal=true;
        },
    },

}
</script>
<style lang="scss">
.edit-creator-modal {
    .ui-modal--container {
        background-color: var(--bg-01);
        width: 620px;
        padding: 24px;
        max-height: 90vh;
        .scrollbar-content{
            max-height: calc(90vh - 100px);
        }
    }

    .edit-header {
        display: flex;
        align-items: center;

        h2 {
            font: var(--font-demi-20);
            color: var(--black-90);
            flex: 1;
            line-height: 1;
        }

        i {
            height: 12px;
            width: 12px;
            position: relative;
            display: block;
            cursor: pointer;

            svg {
                height: 12px;
                width: 12px;
                fill: var(--black-50);
            }
        }
    }

    .user-info {
        display: flex;
        margin: 40px 0;
        align-items: center;

        figure {
            height: 68px;
            width: 68px;

            img {
                height: 100%;
                width: 100%;
                display: block;
                object-fit: cover;
                border-radius: 50%;
                border: 1px solid var(--black-50);
            }

            &+div {
                padding: 0 24px;
                font: var(--font-fg-12);
                color: var(--black-90);
                min-width: 132px;

                &::before {
                    display: block;
                    content: 'Motom Status';
                    color: var(--black-60);
                    margin-bottom: 10px;
                    font-weight: 500;
                }

                &+div {
                    flex: 1;
                    font: var(--font-fg-12);


                    p {
                        display: flex;
                        align-items: center;

                        .ui-switch {
                            margin-left: 6px;
                        }

                        &.disabled {
                            color: var(--gray-blue);
                        }

                        &.active,
                        &.active {
                            color: var(--green);
                        }

                        &.not-available {
                            color: var(--black-40);
                            pointer-events: none;
                        }
                    }

                    &::before {
                        display: block;
                        content: 'Storefront';
                        color: var(--black-60);
                        margin-bottom: 10px;
                        font-weight: 500;
                    }
                }
            }


        }


        .link {
            a {
                display: flex;
                align-items: center;

                svg {
                    height: 18px;
                    width: 18px;
                    display: block;
                    margin-left: 10px;
                    fill: var(--blue);
                }

                &:hover svg {
                    fill: var(--dark-blue);

                }
            }
        }
    }

    .user-form-wrap {
        .name-box {
            display: flex;

            .name-item {
                width: calc((100% - 12px) / 2);

                &:first-child {
                    margin-right: 12px;
                }
            }
        }

        .w-100-p-check{
            width: 100%;
        }

        .label {
            font: var(--font-fg-16);
            color: var(--black-90);

            &:after {
                content: ' *';
                color: var(--alert);
            }
        }

        .switch-box {
            margin: 8px 0 16px;
            padding-right: 42px;
            position: relative;

            .ui-switch {
                position: absolute;
                right: 8px;
                top: 50%;
                margin-top: -8px;
            }
        }

        .desc {
            font-size: 14px;
            color: var(--black-75);
        }

        .ico-social {
            margin: 12px 0;
            display: flex;
            align-items: center;
            font: var(--fond-med-14);
            color: var(--black-75);

            &>span {
                margin-left: 8px;
                cursor: pointer;
            }

            svg {
                height: 14px;
                width: 14px;
                margin-right: 5px;
                display: block;
            }
        }

        .alert-text {
            margin: 12px 0 0;
            padding: 8px;
            font-size: 12px;
            color: var(--black-90);
            background-color: var(--bg-07);
        }

        .ui-input {
            margin: 12px 0;
        }

        .ui-input--icon-wrap .befter-icon {
            margin-left: 10px;
        }

        .ui-input--wrap input,
        .ui-input--icon-wrap {
            border-radius: 0;
        }

        .ui-input--icon-wrap input,
        .ui-input--wrap input {
            padding: 10px;
        }

        .ui-input--icon-wrap .befter-text+input {
            padding-left: 0;
        }

        .btn-wrap {
            display: flex;
            justify-content: flex-end;
            position: sticky;
            bottom: 0px;
            background: var(--white);

            .ui-button {
                width: 100%;//110px;
                text-align: center;
            }
        }

        &.is-error {

            .ui-input .ui-input--wrap select,
            .ui-input .ui-input--wrap input,
            .ui-input .ui-input--select select,
            .ui-input .ui-input--select input,
            .ui-input .ui-input--icon-wrap {
                border-color: var(--alert) !important;
            }

            .error-msg {
                margin: 4px 0 0;
                font-size: 12px;
                color: var(--alert);

                &::before {
                    content: '*';
                }
            }
        }

        .coll-chec{
            margin-top: 16px;

            .ui-checkbox{
                margin-top: 8px;
            }
        }
        
        .tag-line {
            margin-top: 8px;
            display: flex;
            align-items: center;

            dt {
                font: var(--font-med-14);
                color: var(--black-90);
            }

            dd {
                display: flex;
                align-items: center;
                margin-left: 12px;


                span {
                    font-size: 12px;
                    color: var(--black-90);
                    background-color: var(--bg-10);
                    padding: 4px 8px;
                    border-radius: 4px;
                }

            }
        }

        .program-tag-box-big{
            position:relative;
            label{
                &:after{
                    display:none;
                }
            }
        }

        .program-tag-box {
            border-radius: 6px;
            margin: 8px 0 0;
            display: flex;
            align-items: center;
            position:relative;

            dl {
                display: flex;
                align-items: center;
                width:100%;
            }

            dt {
                font: var(--font-med-14);
                color: var(--black-90);
                display: flex;
                align-items: center;
                
                svg {
                    width: 20px;
                    height: 20px;
                    fill: var(--black-90);
                    margin-right: 6px;
                }
            }

            dd {
                padding-left: 12px;
                display: flex;
                align-items: center;

                span {
                    display: inline-flex;
                    height: 24px;
                    border-radius: 4px;
                    background-color: white;
                    padding: 0 6px;
                    align-items: center;
                    font-size: 12px;
                }


                &.program-tag-box-dd{
                    cursor:pointer;
                    display:flex;
                    align-items: center;
                    flex-wrap: wrap;
                    padding:4px;
                    gap:6px;
                    margin-left:0px;
                    flex:1;

                    &.edit-program-tag-box-dd{
                        border:solid 1px var(--neutral);
                        border-radius:6px;
                    }

                    .my-badges-iden{
                        display:flex;
                        align-items: center;
                        border-radius: 6px;
                        svg {
                            height: 8px;
                            width: 8px;
                            margin-left: 6px;
                        }

                        span{
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            max-width: 100px;
                            background:unset;
                            display:unset;
                            height: unset;
                            padding: unset;
                        }
                    }

                    .add-tag-btn{
                        padding: 4px;
                        border:solid 1px var(--neutral);
                        border-radius:6px;
                        height: 24px;
                        display: flex;
                        align-items: center;

                        .svg-icon{
                            margin: unset;
                            width: 14px;
                        }
                    }
                }
            }
        }
    }

    &.is-loading {

        .user-info,
        .user-form-wrap {
            opacity: .5;
            pointer-events: none;
        }
    }


}

.width-380 {
    .ui-modal--container {
        width: 380px !important;
    }
}
</style> 

